// extracted by mini-css-extract-plugin
module.exports = {"knapp":"KnappPart_knapp__pJH1N"};